<li *appHasPermission="'edgeDevice.write'" [class.disabled]="isSelectedDeviceOffline">
    <app-standard-toggle-switch
        [ngbTooltip]="getRemainingActiveLiveData.message"
        [disableTooltip]="getRemainingActiveLiveData.remainingInMinutes <= 0"
        [infoText]="'deviceDetails.actions.liveData.tooltip' | translation | async"
        placement="auto"
        class="toolboxToggle"
        [label]="'deviceDetails.actions.liveData.title' | translation | async"
        [toggledLabel]="'defaults.on' | translation | async"
        [notToggledLabel]="'defaults.off' | translation | async"
        [rectangularSwitch]="false"
        [(ngModel)]="isLiveDataActivated"
        (toggleChanged)="toggleLiveData($event)"
    ></app-standard-toggle-switch>
</li>
